import React, { Component } from "react";
import PropTypes from "prop-types";

class ProgressBar extends Component {
  constructor(props) {
    super(props);

    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    let categories = document.querySelector(".cats-c");

    if (categories == null) {
      categories = document.querySelector(".cats-ph");
    }

    if (categories == null) {
      categories = document.querySelector(".related-c");
    }

    if (categories) {
      this.top = categories.getBoundingClientRect().top;
      window.addEventListener("scroll", this.handleScroll);
    }

    const element = document.getElementById("progressbar");
    if (element) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            element.classList.toggle("pinned", entry.intersectionRatio < 1);
          })
        },
        { threshold: [1] }
      );

      observer.observe(document.getElementById("progressbarHook"));
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll() {
    const documentScroll = document.documentElement.scrollTop || document.body.scrollTop;
    const documentHeight = document.documentElement.clientHeight || document.body.clientHeight;

    let scrolled = (documentScroll / (this.top - documentHeight)) * 100;
    if (scrolled > 100) {
      scrolled = 100;
    }

    document.getElementById("progressBar").style.width = scrolled + "%";
  }

  render() {
    const oneColumn = document.getElementsByClassName("one-column-detail");
    const className = oneColumn.length > 0
      ? "scrollContainer"
      : this.props.fullWidth === true
        ? "scrollContainer"
        : "scrollContainer col-sm-8";

    return (
      <div className={className}>
        <div className="progressContainer">          
          <div className="progressBar" id="progressBar"></div>
        </div>
      </div>
    );
  }
}

ProgressBar.propTypes = {
  fullWidth: PropTypes.bool
};

export default ProgressBar;
